import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Divider,
  Input,
  Button,
  Tooltip,
  Select,
  Row,
  Col,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { StatusSwitch } from "../../Common/StatusSwitch";
import {
  defaultSort,
  getTablePagesize,
  selectFilterFunction,
  setTablePageSize,
} from "../../../Constants/Utilities";
import {
  rowLayout,
  colLayout,
  ConfigActions,
  StatusFilters,
  TablePageSizes,
  TablePages,
  GroupPurpose,
  EntityStatus,
} from "../../../Constants/Constants";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

class ListGroupConfig extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListGroupConfig props", props);
    this.state = {
      groupConfigData: props.groupConfigData,
    };
  }

  componentDidUpdate(prevProps) {
    const { providerData, groupData, groupConfigData } = this.props;
    if (
      prevProps.groupData !== groupData ||
      prevProps.providerData !== providerData ||
      prevProps.groupConfigData !== groupConfigData
    ) {
      this.setState({
        providerData,
        groupData: groupData.filter(
          (item) => item.purpose === GroupPurpose.entitlement.value
        ),
        groupConfigData,
      });
    }
  }

  getColumns = () => [
    {
      title: "Configuration Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ConfigActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Config">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ConfigActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Config">
            <EditOutlined
              onClick={this.props.onActionClick(ConfigActions.edit, record)}
            />
          </Tooltip>
          {record.status === EntityStatus.INACTIVE && (
            <Tooltip title="Delete Config">
              <Popconfirm
                okText="Yes"
                cancelText="No"
                title="Are you sure want to Delete Config?"
                onConfirm={() => this.props.deleteGroupConfig(record)}
              >
                <DeleteOutlined />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { groupConfigData } = this.props;
    if (!!text) {
      const filteredData = groupConfigData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ groupConfigData: filteredData });
      return;
    }
    this.setState({ groupConfigData });
  };

  render() {
    const { groupConfigData } = this.state;
    const {
      providerData,
      providerDataLoading,
      groupData,
      groupDataLoading,
      onActionClick,
      selectedGroup,
      selectedProvider,
      onGroupSelect,
      deleteConfigLoading,
      onProviderSelect,
      groupConfigDataLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <Row {...rowLayout}>
          <Col {...colLayout}>
            <div className="entity-selection-container">
              <span className="entity-label">Service Provider:</span>
              <Select
                showSearch
                allowClear
                value={selectedProvider}
                loading={providerDataLoading}
                disabled={providerDataLoading}
                onChange={onProviderSelect}
                filterOption={selectFilterFunction}
                style={{ minWidth: "250px", maxWidth: "300px" }}
                placeholder={
                  providerDataLoading
                    ? "Loading Service Providers..."
                    : "Select Service Provider"
                }
              >
                {providerData?.map((item) => (
                  <Select.Option
                    key={item.providerId}
                    title={item.providerName}
                  >
                    {item.providerName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col {...colLayout}>
            <div className="entity-selection-container">
              <span className="entity-label">Group:</span>
              <Select
                showSearch
                allowClear
                value={selectedGroup}
                loading={groupDataLoading}
                disabled={!selectedProvider || groupDataLoading}
                onChange={onGroupSelect}
                filterOption={selectFilterFunction}
                style={{ minWidth: "250px", maxWidth: "300px" }}
                placeholder={
                  !selectedProvider
                    ? "Select Provider to view Groups"
                    : groupDataLoading
                    ? "Loading Groups..."
                    : "Select Group"
                }
              >
                {groupData?.map((item) => (
                  <Select.Option key={item.groupId} title={item.groupName}>
                    {item.groupName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Config Name"
              onChange={this.onSerchTextChange}
              disabled={!selectedGroup}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ConfigActions.add, null)}
            >
              Add Configuration
            </Button>
          </div>
        </div>
        {!selectedGroup ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Group to view configurations
            </div>
          </div>
        ) : (
          <Table
            bordered
            size="small"
            columns={this.getColumns()}
            className="entity-table"
            loading={
              groupConfigDataLoading ||
              (deleteConfigLoading && {
                tip: "Fetching Configurations...",
              })
            }
            dataSource={groupConfigData}
            pagination={{
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              defaultPageSize: getTablePagesize(TablePages.listSupportView),
              pageSizeOptions: TablePageSizes,
              onChange: (_, pageSize) =>
                setTablePageSize(TablePages.listSupportView, pageSize),
            }}
          />
        )}
      </div>
    );
  }
}

ListGroupConfig.propTypes = {
  providerData: PropTypes.array,
  providerDataLoading: PropTypes.bool,
  deleteConfigLoading: PropTypes.bool,
  selectedProvider: PropTypes.string,
  groupData: PropTypes.array,
  groupDataLoading: PropTypes.bool,
  selectedGroup: PropTypes.string,
  groupConfigData: PropTypes.array,
  groupConfigDataLoading: PropTypes.bool,
  onProviderSelect: PropTypes.func,
  onGroupSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListGroupConfig;
